import {
    buildLocalBusinessSchema,
    buildProductSchema,
    buildBreadcrumbSchema,
    buildFAQSchema,
    buildSpeakableSchema,
} from "../../../shared/seo/schemas";
import type { SeoHeadProps } from "../../../shared/seo/SeoHead";
import { SITE_BASE } from "../../../shared/seo/siteUrl";

const BASE = SITE_BASE;
const URL = `${BASE}/products/fringes`;

const FAQS = [
    { q: "What types of fringes do you manufacture?", a: "We manufacture tassel fringe, bullion fringe, brush fringe, loop fringe, ball fringe and beaded fringe at our Delhi factory. All available in custom widths from 2cm to 30cm." },
    { q: "What is the minimum order quantity for fringe?", a: "Our standard MOQ is 100 metres per design and colour. Custom-coloured or branded orders begin at 300 metres. Bulk discounts apply above 1000 metres." },
    { q: "Can you supply fringe in custom widths and colours?", a: "Yes — custom widths up to 30cm and full Pantone colour matching are available. We work with fashion brands, interior designers and upholstery manufacturers worldwide." },
    { q: "Do you export fringe trims from India?", a: "Yes, we export to 50+ countries with full export documentation, HS Code 5808.90 and ISO quality certification." },
    { q: "Which industries use your fringes?", a: "Our fringes are used in fashion garments, bridal couture, home upholstery, curtains, cushions, lampshades, automotive interiors and decorative crafts." },
];

export const FringesPageSeo: SeoHeadProps = {
    title: "Fringes Manufacturer Delhi | Wholesale Trim Supplier India | Arte Craft India",
    description:
        "Decorative fringe trims manufacturer in Delhi. Tassel fringe, bullion, brush, loop & beaded fringe. Custom widths 2cm–30cm. Wholesale & export. Fashion, upholstery, decor. MOQ 100 metres.",
    keywords:
        "fringe manufacturer Delhi, decorative fringe India, tassel fringe wholesale, bullion fringe supplier, brush fringe India, beaded fringe manufacturer, upholstery fringe Delhi, fashion fringe India, garment fringe supplier, custom fringe OEM, fringe trim manufacturer, decorative trim Delhi",
    canonical: URL,
    author: "Arte Craft India",
    robots: "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1",

    ogType: "product",
    ogUrl: URL,
    ogSiteName: "Arte Craft India",
    ogImage: `${BASE}/images/fringes-og.jpg`,
    ogImageAlt: "Decorative fringe trims — tassel, bullion, brush, loop — from Arte Craft India Delhi",
    ogLocale: "en_IN",
    ogLocaleAlternates: ["en_US", "en_GB", "en_AU", "en_AE"],

    twitterCard: "summary_large_image",
    twitterSite: "@ArteCraftIndia",
    twitterCreator: "@ArteCraftIndia",
    twitterImage: `${BASE}/images/fringes-twitter.jpg`,
    twitterImageAlt: "Decorative fringe trims from Arte Craft India Delhi manufacturer",
    twitterLabel1: "Types",
    twitterData1: "Tassel · Bullion · Brush · Loop · Beaded",
    twitterLabel2: "MOQ",
    twitterData2: "100 metres — bulk discount from 1000m",

    aiBots: true,

    geoRegion: "IN-DL",
    geoPlacename: "Badarpur, New Delhi, India",
    geoPosition: "28.5045;77.2855",

    dublinCore: {
        title: "Fringes Manufacturer Delhi | Wholesale Trim Supplier India",
        creator: "Arte Craft India",
        subject: "Fringes, Decorative Trim, Manufacturing, Wholesale, Export, Delhi, India",
        description: "Decorative fringe trim manufacturer in Delhi for fashion, upholstery and home decor.",
        publisher: "Arte Craft India Pvt Ltd, Delhi",
        date: "2026-05-26",
        type: "Service, Product Catalog, Manufacturer Profile",
        language: "en",
        rights: "© 2026 Arte Craft India Pvt Ltd. All rights reserved.",
    },

    hreflangs: [
        { lang: "en-IN", url: URL },
        { lang: "en-US", url: URL },
        { lang: "en-GB", url: URL },
        { lang: "en-AU", url: URL },
        { lang: "en-AE", url: URL },
        { lang: "en", url: URL },
        { lang: "x-default", url: URL },
    ],

    productBrand: "Arte Craft India",
    productAvailability: "in stock",
    productCondition: "new",
    productPriceAmount: "40.00",
    productPriceCurrency: "INR",
    productMaterial: "Cotton · Silk · Wool · Metallic blends",
    productColor: "150+ shades with Pantone matching",
    productSize: "Widths 2cm – 30cm; custom available",
    productCategory: "Apparel & Accessories > Trims > Fringes",

    themeColor: "#1B4F72",

    jsonLd: [
        buildLocalBusinessSchema(),
        buildProductSchema({
            name: "Fringes & Decorative Trim — Tassel · Bullion · Brush · Loop · Beaded",
            sku: "AC-FRINGE-001",
            canonicalUrl: URL,
            imageSlug: "fringes",
            description:
                "Decorative fringe trim manufactured in Delhi. Tassel, bullion, brush, loop and beaded fringe in custom widths 2cm–30cm. Wholesale & export.",
            material: "Cotton · Silk · Wool · Metallic blends",
            color: "150+ shades",
            category: "Apparel & Accessories > Trims > Fringes",
            lowPrice: "40",
            highPrice: "450",
        }),
        buildBreadcrumbSchema([
            { name: "Home", url: `${BASE}/` },
            { name: "Products", url: `${BASE}/products` },
            { name: "Fringes", url: URL },
        ]),
        buildFAQSchema(FAQS),
        buildSpeakableSchema(URL, "Fringes Manufacturer Delhi | Wholesale Trim Supplier India", "fringes"),
    ],
};
